import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import PostCard from "@/components/PostCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LatestUpdates() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/posts`).then(({ data }) => setPosts((data || []).slice(0, 3))).catch(() => setPosts([]));
  }, []);

  if (posts.length === 0) return null;

  return (
    <section className="py-24 md:py-32 border-b border-white/10" data-testid="foundation-latest-updates">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-6">
            <div>
              <p className="overline text-white/55">Latest Updates</p>
              <h2 className="font-serif font-light text-white text-4xl md:text-6xl mt-4 leading-[1.05] tracking-tight">
                The work, <em className="italic">as it happens.</em>
              </h2>
            </div>
            <Link to="/foundation/updates" data-testid="latest-updates-viewall" className="group inline-flex items-center gap-2 overline text-white/70 hover:text-white">
              View all updates <ArrowUpRight size={14} className="hover-arrow" />
            </Link>
          </div>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.06}>
              <PostCard post={p} compact />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
